module.exports = __webpack_public_path__ + "img/Replacement-for-Productivity-Hacks-Structure-Your-Day2-scaled.4b3d2558.jpg";